import React from "react";

/* Overlay-free service hero: the before/after photograph at its own brightness, with the
   headline underneath instead of on top of it. */
export const ServiceHero = ({ image, alt, title, subtitle, maxW = "max-w-5xl" }) => (
  <section className="border-b border-neutral-200 bg-[#f7f7f7] pb-9 pt-8" data-testid="service-hero">
    <div className="mr-container-wide">
      <img
        src={image}
        alt={alt}
        data-testid="service-hero-image"
        className={`mx-auto block w-full ${maxW} shadow-sm ring-1 ring-black/5`}
      />
      <div className="mr-container mt-8 px-0 text-center">
        <h1 className="mr-h1 text-3xl sm:text-4xl" data-testid="service-hero-title">{title}</h1>
        <p className="mx-auto mt-3 max-w-3xl text-base text-[#575757] md:text-lg">{subtitle}</p>
      </div>
    </div>
  </section>
);

export default ServiceHero;
